module.exports = __webpack_public_path__ + "img/permit_rating_legend.5f94d6b5.png";